import { CARD_COLORS } from '@ds/theme/color-mode'

export const getStatusColor = (
    status: string,
): 'success' | 'error' | 'default' | 'warning' | 'primary' | 'secondary' | 'info' => {
    const statusColors: Record<
        string,
        'success' | 'error' | 'default' | 'warning' | 'primary' | 'secondary' | 'info'
    > = {
        Approved: 'success',
        Rejected: 'error',
        'Partially Approved': 'success',
        'Pending Review': 'default',
        'In Progress': 'warning',
        New: 'warning',
        Confirmed: 'success',
    }

    return statusColors[status] ?? 'error'
}

const STATUS_TONES = {
    ok: { bgcolor: CARD_COLORS.statusOkBg, color: CARD_COLORS.answeredText },
    reject: { bgcolor: CARD_COLORS.statusRejectBg, color: CARD_COLORS.statusRejectText },
    wait: { bgcolor: CARD_COLORS.statusWaitBg, color: CARD_COLORS.statusWaitText },
    pending: { bgcolor: CARD_COLORS.disabled, color: CARD_COLORS.statusPendingText },
} as const

const STATUS_TONE_BY_NAME: Record<string, keyof typeof STATUS_TONES> = {
    Approved: 'ok',
    'Partially Approved': 'ok',
    Confirmed: 'ok',
    Rejected: 'reject',
    'Pending Review': 'pending',
    'In Progress': 'wait',
    New: 'wait',
}

export const getStatusTone = (status: string) =>
    STATUS_TONES[STATUS_TONE_BY_NAME[status] ?? 'reject']
